import styled, { css, keyframes } from 'styled-components'

import { AccountSectionNavButton } from '../AccountSectionNavButton/AccountSectionNavButton'
import { breakpoints } from '@src/constants/breakpoints'

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: scroll;
  width: 100%;
`

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 101px;
`

export const StampTotalText = styled.div<{
  loyaltyCardColor: string
  isTermsPage: boolean
  isDisabledText: boolean
}>`
  color: ${({ isDisabledText, loyaltyCardColor }) =>
    !isDisabledText ? `${loyaltyCardColor}` : 'rgba(210, 210, 210, 1)'};

  ${({ isTermsPage }) =>
    !isTermsPage
      ? css`
          margin-left: 6px;
        `
      : css`
          margin-left: 0px;
          margin-top: 4px;
        `}

  font-weight: 700;
  font-size: 12px;
  text-align: center;
`

export const LoyaltyCardLinkContainer = styled(AccountSectionNavButton)<{
  loyaltyCardColor: string
  singleBasketCard: boolean
  isFinalCard: boolean
  showAnimation?: boolean
  isBurgerMenuList?: boolean
}>`
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.brandForeground};
  overflow: hidden;

  ${({ singleBasketCard, isFinalCard, isBurgerMenuList }) =>
    !singleBasketCard &&
    !isBurgerMenuList &&
    !isFinalCard &&
    css`
      margin-right: 16px;
      min-width: 350px;

      @media (max-width: ${breakpoints.tablet}px) {
        width: 300px;
        min-width: 300px;
      }
    `}

  ${({ isFinalCard, isBurgerMenuList }) =>
    isFinalCard &&
    !isBurgerMenuList &&
    css`
      min-width: 350px;
      margin-right: 88px;

      @media (max-width: ${breakpoints.tablet}px) {
        width: 300px;
        min-width: 300px;
      }
    `}

${({ isBurgerMenuList, loyaltyCardColor }) =>
    isBurgerMenuList
      ? css`
          border-bottom: 2px solid #ebecf0;
          &:hover {
            color: ${({ theme }) => theme.colors.brand};
            background-color: #f6f6f9;
          }
        `
      : css`
          border-radius: 8px;
          border: 2px solid ${loyaltyCardColor};
          &:hover {
            border-color: ${loyaltyCardColor};
            box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
          }
        `}

  ${({ showAnimation, isBurgerMenuList }) =>
    showAnimation &&
    !isBurgerMenuList &&
    css`
      border: none;

      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        width: calc(100% + 4px);
        height: calc(100% + 4px);
        background: linear-gradient(
          60deg,
          #f79533,
          #f37055,
          #ef4e7b,
          #a166ab,
          #5073b8,
          #1098ad,
          #07b39b,
          #6fba82
        );
        border-radius: 10px;
        z-index: -1;
        background-size: 300% 300%;
        animation: animatedgradient 3s ease infinite alternate;
      }

      &::after {
        content: '';
        position: absolute;
        top: 2px;
        left: 2px;
        width: calc(100% - 4px);
        height: calc(100% - 4px);
        background-color: ${({ theme }) => theme.colors.brandForeground};
        border-radius: 6px;
        z-index: 1;
      }

      > * {
        position: relative;
        z-index: 2;
      }
    `}

  @keyframes animatedgradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`

export const LoyaltyCardInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  padding: 0 18px;
`

export const LoyaltyCardTextContainer = styled.div`
  margin-top: 12px;
  width: 100%;
`

export const LoyaltyCardAmountBold = styled.div<{ isBasket: boolean }>`
  font-weight: 700;
  display: inline;
`

export const LoyaltyCardText = styled.div<{
  isTermsPage: boolean
  isBasket: boolean
}>`
  flex-direction: row;
  font-size: 12px;
  white-space: ${({ isTermsPage }) => (isTermsPage ? 'pre-wrap' : 'nowrap')};
  line-height: 18px;
  text-align: left;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 14px;
  }

  ${({ isBasket }) =>
    isBasket &&
    css`
      color: #2e3333;
      align-self: center;
    `}

  ${({ isTermsPage }) =>
    isTermsPage &&
    css`
      font-size: 16px;
    `}
`

export const TitleAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 28px;
  justify-content: space-between;

  @media (min-width: ${breakpoints.tablet}px) {
    height: 40px;
  }
`

export const LoyaltyCardTitle = styled.div<{ loyaltyCardColor: string }>`
  flex-direction: row;
  font-size: 14px;
  white-space: nowrap;
  color: ${({ loyaltyCardColor }) => loyaltyCardColor};
  font-weight: 700;

  @media (min-width: ${breakpoints.tablet}px) {
    font-size: 14px;
  }
`

export const LoyaltyCardIconAndTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
`

export const DescriptionAndStampsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  justify-content: space-evenly;
  height: 92px;
  width: 80%;
  align-items: flex-start;
`

export const StampAndProgressMeterContainer = styled.div<{
  canStampBeEarned: boolean
  isEndStamp: boolean
  isTermsPage: boolean
  index: number
  requiredStamps: number
}>`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  opacity: ${({ canStampBeEarned }) => (canStampBeEarned ? '1.0' : '0.4')};
  width: ${({ isEndStamp, isTermsPage, index, requiredStamps }) => {
    if (isTermsPage) {
      if (
        index + 1 === requiredStamps ||
        (requiredStamps >= 5 && (index === 4 || index === 9))
      ) {
        return '33px'
      } else return '72px'
    }
    if (isEndStamp && !isTermsPage) {
      return '21px'
    } else return '100%'
  }};
`
export const StampsContainer = styled.div<{
  isTermsPage: boolean
  isOutletList: boolean
  requiredStamps: number
  isBasket: boolean
  isSingleOrder: boolean
}>`
  display: flex;
  align-items: center;
  position: relative;
  z-index: 0;

  ${({
    isTermsPage,
    isOutletList,
    requiredStamps,
    isBasket,
    isSingleOrder,
  }) => {
    if (isSingleOrder) {
      return css`
        width: 100px;
        min-width: 100px;
        max-width: 100px;

        @media (max-width: ${breakpoints.tablet - 1}px) {
          // The -1 a bit hacky but desired tablet breakpoint falls on exact max-width pixel
          width: 160px;
          min-width: 160px;
          max-width: 160px;
        }

        @media (min-width: ${breakpoints.wideDesktop}px) {
          width: 160px;
          min-width: 160px;
          max-width: 160px;
        }
      `
    }
    if (isTermsPage) {
      if (requiredStamps > 5) {
        return css`
          flex-wrap: wrap;
          width: 328px;
          height: 120px;
        `
      } else
        return css`
          justify-content: center;
          width: 360px;
        `
    }
    if (isOutletList) {
      return css`
        max-width: 170px;
        min-width: 170px;
      `
    }
    if (isBasket) {
      return css`
        max-width: 150px;
        min-width: 150px;

        @media (max-width: ${breakpoints.largeMobile}px) {
          max-width: 160px;
          min-width: 160px;
          width: 160px;
        }
      `
    } else {
      return css`
        max-width: 200px;
        min-width: 200px;
        width: 200px;

        @media (max-width: ${breakpoints.tablet}px) {
          max-width: 160px;
          min-width: 160px;
          width: 160px;
        }
      `
    }
  }}
`

export const StampBackground = styled.div<{
  hasStampBeenUsed: boolean
  loyaltyCardColor: string
  isLastEarnedStamp: boolean
  isStartStamp: boolean
  isEndStamp: boolean
  imageUrl?: string
  scale: number
  shouldShowAsSlider: boolean
  isTermsPage: boolean
  numberOfStamps: number
  showAnimation: boolean
  shouldShowNextStamp: boolean
  isOutletList: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: white;

  ${({ isTermsPage, isOutletList }) =>
    isTermsPage
      ? css`
          min-width: 37px;
          max-width: 37px;
          height: 37px;
          left: -2px;
          top: -2px;
        `
      : isOutletList
      ? css`
          min-width: 21px;
          max-width: 21px;
          height: 21px;
          right: 5px;
          left: -1px;
          top: -1px;
        `
      : css`
          min-width: 25px;
          max-width: 25px;
          height: 25px;
          right: 5px;
          left: -1px;
          top: -1px;
        `}

  font-weight: 700;
  z-index: 1;

  position: absolute;
  background-color: white;

  ${({
    shouldShowAsSlider,
    isStartStamp,
    isEndStamp,
    isLastEarnedStamp,
    shouldShowNextStamp,
  }) => {
    if (
      shouldShowAsSlider &&
      !isStartStamp &&
      !isEndStamp &&
      !isLastEarnedStamp &&
      !shouldShowNextStamp
    ) {
      return css`
        display: none;
      `
    }
  }}

  ${({ hasStampBeenUsed }) =>
    !hasStampBeenUsed &&
    css`
      background-color: rgba(210, 210, 210, 1);
    `};

  clip-path: url(#scalloped-mask-${({ scale }) => scale});
  border-radius: 24px;
  overflow: hidden;

  ${({ loyaltyCardColor, showAnimation }) =>
    showAnimation &&
    css`
      animation: ${stampBackgroundFadeInOut(loyaltyCardColor)} 1s ease-in
        infinite;
      animation-delay: 1s;
    `}
`

export const Stamp = styled.div<{
  hasStampBeenUsed: boolean
  loyaltyCardColor: string
  isLastEarnedStamp: boolean
  isStartStamp: boolean
  isEndStamp: boolean
  imageUrl: string
  scale: number
  shouldShowAsSlider: boolean
  isTermsPage: boolean
  numberOfStamps: number
  shouldShowNextStamp: boolean
  isOutletList: boolean
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  ${({ isTermsPage, isOutletList }) =>
    isTermsPage
      ? css`
          min-width: 33px;
          max-width: 33px;
          height: 33px;
        `
      : isOutletList
      ? css`
          min-width: 19px;
          max-width: 19px;
          height: 19px;
        `
      : css`
          min-width: 23px;
          max-width: 23px;
          height: 23px;
        `}

  ${({
    shouldShowAsSlider,
    isStartStamp,
    isEndStamp,
    isLastEarnedStamp,
    shouldShowNextStamp,
  }) => {
    if (
      shouldShowAsSlider &&
      !isStartStamp &&
      !isEndStamp &&
      !isLastEarnedStamp &&
      !shouldShowNextStamp
    ) {
      return css`
        display: none;
      `
    }
  }}

  ${({
    imageUrl,
    shouldShowAsSlider,
    isStartStamp,
    hasStampBeenUsed,
    numberOfStamps,
  }) => {
    if (
      imageUrl &&
      hasStampBeenUsed &&
      (!shouldShowAsSlider ||
        (isStartStamp && shouldShowAsSlider && numberOfStamps > 1))
    ) {
      return css`
        background-image: url(${imageUrl});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-color: #bbb;
      `
    }
  }}

  clip-path: url(#scalloped-mask-${({ scale }) => scale});

  ${({ loyaltyCardColor, hasStampBeenUsed }) =>
    loyaltyCardColor && hasStampBeenUsed
      ? css`
          background-color: ${loyaltyCardColor};
        `
      : css`
          background-color: #fff;
        `}

  border-radius: 24px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 2;
  position: relative;
`

export const StampText = styled.div<{
  hasStampBeenUsed: boolean
  isTermsPage: boolean
  showAnimation: boolean
  loyaltyCardColor: string
}>`
  font-weight: 700;
  font-size: ${({ isTermsPage }) => (isTermsPage ? '14px' : '10px')};

  color: ${({ hasStampBeenUsed }) =>
    hasStampBeenUsed ? '#fff' : 'rgba(210, 210, 210, 1)'};

  ${({ loyaltyCardColor, showAnimation }) =>
    showAnimation &&
    css`
      animation: ${stampTextFadeInOut(loyaltyCardColor)} 1s ease-in infinite;
      animation-delay: 1s;
    `}
`

export const AmountEarnedOnStampContainer = styled.div`
  height: 14px;
`

export const StampProgressMeter = styled.div<{
  hasStampBeenUsed: boolean
  loyaltyCardColor: string
  requiredStamps: number
  isOutletList: boolean
  isMobile: boolean
  isTermsPage: boolean
  isBasket: boolean
  index: number
  showAnimation: boolean
  isBackground: boolean
  includeExtraSpacing: boolean
}>`
  ${({ isTermsPage }) =>
    isTermsPage
      ? css`
          margin-bottom: 16px;
          margin-left: -1px;
          height: 5px;
        `
      : css`
          height: 4px;
        `};

  ${({ index, requiredStamps, isTermsPage }) =>
    requiredStamps >= 5 &&
    isTermsPage &&
    index === 4 &&
    css`
      display: none;
    `};
  z-index: 0;

  ${({ includeExtraSpacing }) =>
    includeExtraSpacing
      ? css`
          width: 8px;
        `
      : 'width: 100%;'}

  background-color: ${({ hasStampBeenUsed, loyaltyCardColor, isBasket }) => {
    if (hasStampBeenUsed) {
      return `${loyaltyCardColor}`
    } else if (isBasket) {
      return `#fff`
    } else return 'rgba(243, 243, 243, 1)'
  }};

  position: ${({ isBackground }) => (isBackground ? 'absolute' : 'relative')};

  ${({ loyaltyCardColor, showAnimation }) =>
    showAnimation &&
    css`
      animation: ${fillProgressMeter(loyaltyCardColor)} 1s ease-in infinite;
      animation-delay: 0s;
    `}
`

export const LoyaltyCardImage = styled.div<{
  imageUrl: string
  isTermsPage?: boolean
  scale: number
  canStampBeEarned: boolean
  isCheckout?: boolean
  useClipPath?: boolean
}>`
  background-size: cover;

  ${({ isTermsPage, isCheckout }) => {
    if (isTermsPage) {
      return css`
        min-width: 87px;
        min-height: 87px;
      `
    }
    if (isCheckout) {
      return css`
        min-width: 32px;
        min-height: 32px;
      `
    } else
      return css`
        min-width: 60px;
        min-height: 60px;
      `
  }}

  background-color: grey;
  opacity: ${({ canStampBeEarned }) => (canStampBeEarned ? '1.0' : '0.4')};

  position: relative;
  ${({ imageUrl }) =>
    imageUrl &&
    css`
      background-image: url(${imageUrl});
    `}

  ${({ useClipPath = true, scale }) =>
    useClipPath
      ? css`
          clip-path: url(#scalloped-mask-large-${scale});
          border-radius: 30px;
        `
      : css`
          border-radius: 8px;
        `}
`
export const LoyaltyCardSliderContainer = styled.div<{
  singleBasketCard?: boolean
}>`
  margin-bottom: 18px;
  position: relative;

  z-index: 0;

  ${({ singleBasketCard }) =>
    singleBasketCard &&
    css`
      .swiper,
      .swiper-wrapper,
      .swiper-slide {
        width: 100% !important;
      }
    `}
`

export const LoyaltyCardName = styled.p<{ loyaltyCardColor: string }>`
  font-weight: 700;
  color: ${({ loyaltyCardColor }) => loyaltyCardColor};
  font-size: 18px;
  display: flex;
  justify-content: center;
`
const fillProgressMeter = (color: string) => keyframes`
  0% {
    width: 0%;
    background-color: #fff;
    opacity: 1;
  }
  50% {
    width: 100%;
    background-color: ${color};
    opacity: 1;
  }
  90% {
    width: 100%;
    background-color: rgba(243, 243, 243, 1);
    opacity: 1;
  }
`

const stampBackgroundFadeInOut = (color: string) => keyframes`
  0% {
    background-color: rgba(210, 210, 210, 1);
  }
  40% {
    background-color: rgba(210, 210, 210, 1);
  }
  50% {
    background-color: ${color};
  }
  70% {
    background-color: ${color};
  }
  100% {
    background-color: rgba(210, 210, 210, 1);
  }
`
const stampTextFadeInOut = (color: string) => keyframes`
  0% {
    color: rgba(210, 210, 210, 1);
  }
  40% {
    color: rgba(210, 210, 210, 1);
  }
  50% {
    color: ${color};
  }
  70% {
    color: ${color};
  }
  100% {
    color: rgba(210, 210, 210, 1);
  }
`
